import { tokens } from '@equinor/eds-tokens';

var _tokens$colors$infogr = tokens.colors.infographic,
  primary13 = _tokens$colors$infogr.primary__moss_green_13.rgba,
  primary100 = _tokens$colors$infogr.primary__moss_green_100.rgba;
var primary = {
  background: primary13,
  entities: {
    progress: {
      background: primary100
    }
  }
};

export { primary };
